import { render } from "./CategorizedItems.vue?vue&type=template&id=56e4e839"
import script from "./CategorizedItems.vue?vue&type=script&lang=js"
export * from "./CategorizedItems.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/.pnpm/vue-loader@17.4.2_@vue+compiler-sfc@3.5.35_vue@3.5.35_typescript@4.9.5__webpack@5.107.2_postcss@8.5.8_/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__